/**
 * Client-side gameplay settings (persisted in localStorage, one key per option).
 * Read hot-path options via the getter each frame — they're plain field reads.
 */

const INVERT_KEY = "gl-invert-mouse";

let invertMouse = localStorage.getItem(INVERT_KEY) === "1";

/** Whether vertical camera look is INVERTED (drag up → look down). */
export function getInvertMouse(): boolean { return invertMouse; }

export function setInvertMouse(on: boolean): void {
  invertMouse = on;
  localStorage.setItem(INVERT_KEY, on ? "1" : "0");
}
